import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import Text from '../text/text.component.js';
import '../../App.css.js';
var _excluded = ["style", "width", "height", "selected", "icon", "small", "titleText", "captionText", "linkText", "LinkComponent", "link", "linkIcon", "theme", "comingSoon", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var LinkDiv = styled.div.withConfig({
  displayName: "testimonial-cardcomponent__LinkDiv",
  componentId: "sc-epgg6a-0"
})([""]);
var Div = styled.div.withConfig({
  displayName: "testimonial-cardcomponent__Div",
  componentId: "sc-epgg6a-1"
})(["padding-top:24px;padding-left:24px;padding-right:24px;padding-bottom:24px;border-radius:16px;box-shadow:0px 9px 33px rgba(0,0,0,0.1);.text-link-card{color:var(--green) !important;}@media screen and (max-width:768px){padding-top:24px;padding-left:24px;padding-right:24px;padding-bottom:24px;border-radius:16px;}"]);
var LandingCard = function LandingCard(_ref) {
  var style = _ref.style,
    width = _ref.width;
  _ref.height;
  _ref.selected;
  var icon = _ref.icon;
  _ref.small;
  var titleText = _ref.titleText,
    captionText = _ref.captionText;
  _ref.linkText;
  var LinkComponent = _ref.LinkComponent,
    link = _ref.link;
  _ref.linkIcon;
  var theme = _ref.theme,
    comingSoon = _ref.comingSoon,
    className = _ref.className;
  _objectWithoutProperties(_ref, _excluded);
  var LinkObj = link && LinkComponent ? LinkComponent : LinkDiv;
  return /*#__PURE__*/React__default.createElement(Div, {
    className: "link-card " + className,
    style: _objectSpread({
      width: width,
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start"
    }, style)
  }, /*#__PURE__*/React__default.createElement(LinkObj, {
    to: link ? link : "unset",
    title: titleText,
    target: link && link.includes("http") ? "_blank" : "_self",
    style: {
      height: "100%",
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start",
      textDecoration: "none",
      cursor: comingSoon ? "default" : "inherit",
      pointerEvents: comingSoon ? "none" : "auto"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start"
    }
  }, icon && titleText ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      marginBottom: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: "icon",
    className: "card-icon",
    style: {
      width: "48px",
      height: "48px"
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    className: "title-card",
    fontFamily: "euclid",
    type: "label",
    fontSize: "xxlarge",
    style: {
      textAlign: "left",
      marginLeft: "20px"
    }
  }, titleText)) : null, /*#__PURE__*/React__default.createElement(Text, {
    className: "description-card",
    fontFamily: "euclid",
    type: "paragraph",
    fontSize: "medium",
    color: theme.layout == "dark" ? "var(--dark-gray-1)" : "var(--light-gray-1)",
    style: {
      textAlign: "left"
    }
  }, captionText))));
};
var testimonialCard_component = withTheme(LandingCard);
export { testimonialCard_component as default };